"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMTransformer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const IVMBytecodeCompiler_1 = require("../../interfaces/vm-transformers/IVMBytecodeCompiler");
const IVMBytecodeStorage_1 = require("../../interfaces/vm-transformers/IVMBytecodeStorage");
const IVMFunctionSelector_1 = require("../../interfaces/vm-transformers/IVMFunctionSelector");
const IVMGlobalStorageUtils_1 = require("../../interfaces/vm-transformers/IVMGlobalStorageUtils");
const IVMOpcodeMap_1 = require("../../interfaces/vm-transformers/IVMOpcodeMap");
const VMDeadCodeInjector_1 = require("../../vm-transformers/VMDeadCodeInjector");
const VMMacroOpOptimizer_1 = require("../../vm-transformers/bytecode-compiler/optimizers/VMMacroOpOptimizer");
const NodeTransformationStage_1 = require("../../enums/node-transformers/NodeTransformationStage");
const CustomCodeHelperGroup_1 = require("../../enums/custom-code-helpers/CustomCodeHelperGroup");
const CustomCodeHelper_1 = require("../../enums/custom-code-helpers/CustomCodeHelper");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
const NodeFactory_1 = require("../../node/NodeFactory");
const NodeUtils_1 = require("../../node/NodeUtils");
const VMConstants_1 = require("../../vm-transformers/VMConstants");
const VMOpcodeDerivation_1 = require("../../vm-transformers/VMOpcodeDerivation");
const VMStateMachine_1 = require("../../vm-transformers/VMStateMachine");
const NodeAppender_1 = require("../../node/NodeAppender");
const TCustomCodeHelperGroupFactory_1 = require("../../types/container/custom-code-helpers/TCustomCodeHelperGroupFactory");
let VMTransformer = class VMTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(vmBytecodeCompiler, vmBytecodeStorage, vmFunctionSelector, vmGlobalStorageUtils, vmOpcodeMapStorage, vmDeadCodeInjector, vmMacroOpOptimizer, customCodeHelperGroupFactory, randomGenerator, options) {
        super(randomGenerator, options);
        this.runAfter = [];
        this.vmExecutorName = '';
        this.vmCodeHelperGroup = null;
        this.pendingGlobalStorageNodes = [];
        this.topLevelVariables = new Set();
        this.pendingCatchClauses = [];
        this.vmBytecodeCompiler = vmBytecodeCompiler;
        this.vmBytecodeStorage = vmBytecodeStorage;
        this.vmFunctionSelector = vmFunctionSelector;
        this.vmGlobalStorageUtils = vmGlobalStorageUtils;
        this.vmOpcodeMapStorage = vmOpcodeMapStorage;
        this.vmDeadCodeInjector = vmDeadCodeInjector;
        this.vmMacroOpOptimizer = vmMacroOpOptimizer;
        this.customCodeHelperGroupFactory = customCodeHelperGroupFactory;
    }
    getVisitor(nodeTransformationStage) {
        if (!this.options.vmObfuscation) {
            return null;
        }
        switch (nodeTransformationStage) {
            case NodeTransformationStage_1.NodeTransformationStage.VMObfuscation:
                return {
                    enter: (node, parentNode) => {
                        if (NodeGuards_1.NodeGuards.isProgramNode(node)) {
                            this.getVMCodeHelperGroup();
                            this.pendingGlobalStorageNodes = [];
                            this.pendingCatchClauses = [];
                            this.topLevelVariables = new Set();
                        }
                        if (NodeGuards_1.NodeGuards.isClassDeclarationNode(node) &&
                            node.id &&
                            parentNode &&
                            NodeGuards_1.NodeGuards.isProgramNode(parentNode)) {
                            this.pendingGlobalStorageNodes.push({ node, parentNode });
                        }
                        if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node) &&
                            parentNode &&
                            NodeGuards_1.NodeGuards.isProgramNode(parentNode)) {
                            this.pendingGlobalStorageNodes.push({ node, parentNode });
                        }
                        if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node) &&
                            node.id &&
                            parentNode &&
                            NodeGuards_1.NodeGuards.isProgramNode(parentNode)) {
                            this.pendingGlobalStorageNodes.push({ node, parentNode });
                        }
                        if (node.type === 'CatchClause' && node.param) {
                            const catchClause = node;
                            const catchParam = catchClause.param;
                            if (this.containsNestedFunctions(catchClause.body) && catchParam) {
                                this.pendingCatchClauses.push(catchClause);
                                let varNames;
                                if (NodeGuards_1.NodeGuards.isIdentifierNode(catchParam)) {
                                    varNames = [catchParam.name];
                                }
                                else if (NodeGuards_1.NodeGuards.isObjectPatternNode(catchParam) ||
                                    NodeGuards_1.NodeGuards.isArrayPatternNode(catchParam)) {
                                    varNames = this.extractIdentifiersFromPattern(catchParam);
                                }
                                else {
                                    varNames = [];
                                }
                                for (const varName of varNames) {
                                    this.topLevelVariables.add(varName);
                                }
                            }
                        }
                    },
                    leave: (node, parentNode) => {
                        if (parentNode && this.isFunctionNode(node)) {
                            if (this.isNestedFunction(node, parentNode)) {
                                return node;
                            }
                            return this.transformNode(node, parentNode);
                        }
                        if (NodeGuards_1.NodeGuards.isProgramNode(node) && this.vmBytecodeStorage.getLength() > 0) {
                            return this.injectVMRuntime(node);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(functionNode, parentNode) {
        if (!this.vmFunctionSelector.shouldVirtualize(functionNode)) {
            return functionNode;
        }
        if (!functionNode.body) {
            return functionNode;
        }
        if (!NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            return functionNode;
        }
        if (functionNode.body.body.length === 0) {
            return functionNode;
        }
        try {
            return this.compileAndTransformFunction(functionNode, parentNode);
        }
        catch (_a) {
            return functionNode;
        }
    }
    compileAndTransformFunction(functionNode, parentNode) {
        const compilationResult = this.vmBytecodeCompiler.compile(functionNode, this.topLevelVariables);
        if (this.options.vmMacroOps) {
            this.vmMacroOpOptimizer.optimize(compilationResult.bytecode);
            for (const nestedFunc of compilationResult.nestedFunctions) {
                this.vmMacroOpOptimizer.optimize(nestedFunc);
            }
        }
        const nestedFunctionIds = new Map();
        for (let i = 0; i < compilationResult.nestedFunctions.length; i++) {
            const nestedBytecode = compilationResult.nestedFunctions[i];
            const updatedNestedConstants = this.mapNestedFunctionIds(nestedBytecode.constants, nestedFunctionIds, nestedBytecode.functionRefIndices);
            const opcodeConfig = this.generateOpcodeConfig(nestedBytecode.instructions.length, updatedNestedConstants.length);
            const updatedNestedBytecode = {
                ...nestedBytecode,
                constants: updatedNestedConstants,
                ...opcodeConfig,
                ...(this.options.vmJumpsEncoding ? { jumpKey: this.randomGenerator.getRandomInteger(1, 65535) } : {}),
                ...(this.options.vmBytecodeEncoding ? { bytecodeKey: this.randomGenerator.getRandomInteger(1, 0xFF) } : {}),
                ...(this.options.vmStatefulOpcodes ? {
                    smSeed: this.randomGenerator.getRandomInteger(1, 4294967295),
                    smState: this.randomGenerator.getRandomInteger(0, (0, VMStateMachine_1.getNumStates)() - 1)
                } : {}),
                ...(this.options.vmStackEncoding ? { seKey: this.randomGenerator.getRandomInteger(1, 4294967295) } : {})
            };
            const processedNestedBytecode = this.vmDeadCodeInjector.injectDeadCode(updatedNestedBytecode);
            const actualBytecodeId = this.vmBytecodeStorage.store(processedNestedBytecode);
            nestedFunctionIds.set(i, actualBytecodeId);
        }
        const updatedConstants = this.mapNestedFunctionIds(compilationResult.bytecode.constants, nestedFunctionIds, compilationResult.bytecode.functionRefIndices);
        const mainOpcodeConfig = this.generateOpcodeConfig(compilationResult.bytecode.instructions.length, updatedConstants.length);
        const updatedBytecode = {
            ...compilationResult.bytecode,
            constants: updatedConstants,
            ...mainOpcodeConfig,
            ...(this.options.vmJumpsEncoding ? { jumpKey: this.randomGenerator.getRandomInteger(1, 65535) } : {}),
            ...(this.options.vmBytecodeEncoding ? { bytecodeKey: this.randomGenerator.getRandomInteger(1, 0xFF) } : {}),
            ...(this.options.vmStatefulOpcodes ? {
                smSeed: this.randomGenerator.getRandomInteger(1, 4294967295),
                smState: this.randomGenerator.getRandomInteger(0, (0, VMStateMachine_1.getNumStates)() - 1)
            } : {}),
            ...(this.options.vmStackEncoding ? { seKey: this.randomGenerator.getRandomInteger(1, 4294967295) } : {})
        };
        const processedBytecode = this.vmDeadCodeInjector.injectDeadCode(updatedBytecode);
        const bytecodeId = this.vmBytecodeStorage.store(processedBytecode);
        const newBody = this.createVMCallBody(bytecodeId, functionNode, updatedBytecode, parentNode);
        const newFunctionNode = this.createTransformedFunction(functionNode, newBody);
        NodeUtils_1.NodeUtils.parentizeNode(newFunctionNode, parentNode);
        return newFunctionNode;
    }
    generateOpcodeConfig(instrCount, constCount) {
        if (!this.options.vmOpcodeShuffle) {
            return {};
        }
        if (this.options.vmRuntimeOpcodeDerivation) {
            const { seed, opcodeMap } = (0, VMOpcodeDerivation_1.generateSeedOpcodeMapping)(() => this.randomGenerator.getRandomInteger(0, 4294967295), instrCount, constCount);
            return { opcodeSeed: seed, opcodeMap };
        }
        return { opcodeMap: this.vmOpcodeMapStorage.generateNewMapping() };
    }
    mapNestedFunctionIds(constants, nestedFunctionIds, functionRefIndices) {
        return constants.map((constant, index) => {
            if (functionRefIndices &&
                functionRefIndices.has(index) &&
                typeof constant === 'number' &&
                nestedFunctionIds.has(constant)) {
                const actualId = nestedFunctionIds.get(constant);
                if (actualId === undefined) {
                    throw new Error(`[VMTransformer] Failed to find actual bytecode ID for local function ID ${constant}`);
                }
                return actualId;
            }
            return constant;
        });
    }
    getVMCodeHelperGroup() {
        if (!this.vmCodeHelperGroup) {
            this.vmCodeHelperGroup = this.customCodeHelperGroupFactory(CustomCodeHelperGroup_1.CustomCodeHelperGroup.VM);
            this.vmCodeHelperGroup.initialize();
            this.vmExecutorName = this.vmCodeHelperGroup.getVMExecutorName();
        }
        return this.vmCodeHelperGroup;
    }
    createVMCallBody(bytecodeId, functionNode, bytecode, parentNode) {
        const hasRestParam = functionNode.params.some((param) => NodeGuards_1.NodeGuards.isRestElementNode(param));
        const isArrow = NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(functionNode);
        let argumentsArray;
        if (hasRestParam && !isArrow) {
            const arrayFromCall = NodeFactory_1.NodeFactory.callExpressionNode(NodeFactory_1.NodeFactory.memberExpressionNode(NodeFactory_1.NodeFactory.identifierNode('Array'), NodeFactory_1.NodeFactory.identifierNode('from')), [NodeFactory_1.NodeFactory.identifierNode('arguments')]);
            argumentsArray = arrayFromCall;
        }
        else if (hasRestParam && isArrow) {
            const refs = [];
            let hasRestPattern = false;
            for (const param of functionNode.params) {
                if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                    refs.push(NodeFactory_1.NodeFactory.identifierNode(param.name));
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(param)) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(param.argument)) {
                        refs.push(NodeFactory_1.NodeFactory.spreadElementNode(NodeFactory_1.NodeFactory.identifierNode(param.argument.name)));
                    }
                    else {
                        hasRestPattern = true;
                    }
                }
            }
            if (hasRestPattern) {
                argumentsArray = NodeFactory_1.NodeFactory.arrayExpressionNode([
                    NodeFactory_1.NodeFactory.spreadElementNode(NodeFactory_1.NodeFactory.identifierNode(VMConstants_1.VM_SPECIAL_VARS.arrowRestParam))
                ]);
            }
            else {
                argumentsArray = NodeFactory_1.NodeFactory.arrayExpressionNode(refs);
            }
        }
        else if (!isArrow) {
            const arrayFromCall = NodeFactory_1.NodeFactory.callExpressionNode(NodeFactory_1.NodeFactory.memberExpressionNode(NodeFactory_1.NodeFactory.identifierNode('Array'), NodeFactory_1.NodeFactory.identifierNode('from')), [NodeFactory_1.NodeFactory.identifierNode('arguments')]);
            argumentsArray = arrayFromCall;
        }
        else {
            argumentsArray = NodeFactory_1.NodeFactory.arrayExpressionNode(this.createParameterReferences(functionNode));
        }
        const vmExecutorIdentifier = NodeFactory_1.NodeFactory.identifierNode(this.vmExecutorName);
        const callMethodAccess = NodeFactory_1.NodeFactory.memberExpressionNode(vmExecutorIdentifier, NodeFactory_1.NodeFactory.identifierNode('call'));
        const thisExpression = {
            type: 'ThisExpression'
        };
        let currentFuncParam = NodeFactory_1.NodeFactory.identifierNode('undefined');
        if (bytecode.functionNameIndex !== undefined && !isArrow) {
            if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(functionNode) && functionNode.id) {
                currentFuncParam = NodeFactory_1.NodeFactory.identifierNode(functionNode.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(functionNode) && functionNode.id) {
                currentFuncParam = NodeFactory_1.NodeFactory.identifierNode(functionNode.id.name);
            }
        }
        const isDerivedConstructor = NodeGuards_1.NodeGuards.isMethodDefinitionNode(parentNode) &&
            parentNode.kind === 'constructor' &&
            this.hasSuperCall(functionNode);
        if (isDerivedConstructor) {
            return this.createPartiallyObfuscatedConstructor(functionNode, bytecode, bytecodeId, argumentsArray, currentFuncParam, callMethodAccess);
        }
        const vmCall = NodeFactory_1.NodeFactory.callExpressionNode(callMethodAccess, [
            thisExpression,
            NodeFactory_1.NodeFactory.literalNode(bytecodeId),
            argumentsArray,
            NodeFactory_1.NodeFactory.identifierNode('undefined'),
            currentFuncParam
        ]);
        const returnStatement = NodeFactory_1.NodeFactory.returnStatementNode(vmCall);
        const blockStatement = NodeFactory_1.NodeFactory.blockStatementNode([returnStatement]);
        NodeUtils_1.NodeUtils.parentizeAst(blockStatement);
        return blockStatement;
    }
    createParameterReferences(functionNode) {
        const refs = [];
        for (let i = 0; i < functionNode.params.length; i++) {
            const param = functionNode.params[i];
            if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                refs.push(NodeFactory_1.NodeFactory.identifierNode(param.name));
            }
            else if (NodeGuards_1.NodeGuards.isRestElementNode(param)) {
                break;
            }
            else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param) ||
                NodeGuards_1.NodeGuards.isObjectPatternNode(param) ||
                NodeGuards_1.NodeGuards.isAssignmentPatternNode(param)) {
                refs.push(NodeFactory_1.NodeFactory.memberExpressionNode(NodeFactory_1.NodeFactory.identifierNode('arguments'), NodeFactory_1.NodeFactory.literalNode(i), true));
            }
            else {
                refs.push(NodeFactory_1.NodeFactory.memberExpressionNode(NodeFactory_1.NodeFactory.identifierNode('arguments'), NodeFactory_1.NodeFactory.literalNode(i), true));
            }
        }
        return refs;
    }
    hasSuperCall(functionNode) {
        const visited = new Set();
        const checkNode = (node) => {
            if (!node || typeof node !== 'object') {
                return false;
            }
            if (visited.has(node)) {
                return false;
            }
            visited.add(node);
            if (NodeGuards_1.NodeGuards.isSuperNode(node)) {
                return true;
            }
            for (const key in node) {
                if (key === 'parentNode' || key === 'parent') {
                    continue;
                }
                const value = node[key];
                if (Array.isArray(value)) {
                    for (const item of value) {
                        if (checkNode(item)) {
                            return true;
                        }
                    }
                }
                else if (checkNode(value)) {
                    return true;
                }
            }
            return false;
        };
        return checkNode(functionNode.body);
    }
    createPartiallyObfuscatedConstructor(functionNode, originalBytecode, originalBytecodeId, argumentsArray, currentFuncParam, callMethodAccess) {
        const body = functionNode.body;
        let superStatementIndex = -1;
        for (let i = 0; i < body.body.length; i++) {
            if (this.containsSuperCall(body.body[i])) {
                superStatementIndex = i;
                break;
            }
        }
        if (superStatementIndex === -1) {
            throw new Error('[VMTransformer] Expected super() call in derived class constructor');
        }
        const beforeSuperStatements = body.body.slice(0, superStatementIndex + 1);
        const afterSuperStatements = body.body.slice(superStatementIndex + 1);
        if (afterSuperStatements.length === 0) {
            return body;
        }
        const beforeSuperDeclarations = beforeSuperStatements.filter((stmt) => stmt.type === 'VariableDeclaration');
        const tempFunction = {
            type: 'FunctionExpression',
            params: functionNode.params,
            body: NodeFactory_1.NodeFactory.blockStatementNode([
                ...beforeSuperDeclarations,
                ...afterSuperStatements
            ]),
            async: false,
            generator: false
        };
        const compilationResult = this.vmBytecodeCompiler.compile(tempFunction, this.topLevelVariables);
        if (this.options.vmMacroOps) {
            this.vmMacroOpOptimizer.optimize(compilationResult.bytecode);
            for (const nestedFunc of compilationResult.nestedFunctions) {
                this.vmMacroOpOptimizer.optimize(nestedFunc);
            }
        }
        for (const nestedBytecode of compilationResult.nestedFunctions) {
            const processedNestedBytecode = this.vmDeadCodeInjector.injectDeadCode(nestedBytecode);
            this.vmBytecodeStorage.store(processedNestedBytecode);
        }
        const processedBytecode = this.vmDeadCodeInjector.injectDeadCode(compilationResult.bytecode);
        const afterSuperBytecodeId = this.vmBytecodeStorage.store(processedBytecode);
        const afterSuperVmCall = NodeFactory_1.NodeFactory.callExpressionNode(callMethodAccess, [
            NodeFactory_1.NodeFactory.thisExpressionNode(),
            NodeFactory_1.NodeFactory.literalNode(afterSuperBytecodeId),
            argumentsArray,
            NodeFactory_1.NodeFactory.identifierNode('undefined'),
            currentFuncParam,
            NodeFactory_1.NodeFactory.metaPropertyNode(NodeFactory_1.NodeFactory.identifierNode('new'), NodeFactory_1.NodeFactory.identifierNode('target'))
        ]);
        const newStatements = [...beforeSuperStatements, NodeFactory_1.NodeFactory.returnStatementNode(afterSuperVmCall)];
        const blockStatement = NodeFactory_1.NodeFactory.blockStatementNode(newStatements);
        NodeUtils_1.NodeUtils.parentizeAst(blockStatement);
        return blockStatement;
    }
    containsSuperCall(statement) {
        const visited = new Set();
        const checkNode = (node) => {
            if (!node || typeof node !== 'object') {
                return false;
            }
            if (visited.has(node)) {
                return false;
            }
            visited.add(node);
            if (NodeGuards_1.NodeGuards.isSuperNode(node)) {
                return true;
            }
            for (const key in node) {
                if (key === 'parentNode' || key === 'parent') {
                    continue;
                }
                const value = node[key];
                if (Array.isArray(value)) {
                    for (const item of value) {
                        if (checkNode(item)) {
                            return true;
                        }
                    }
                }
                else if (checkNode(value)) {
                    return true;
                }
            }
            return false;
        };
        return checkNode(statement);
    }
    createTransformedFunction(originalFunction, newBody) {
        if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(originalFunction)) {
            const functionName = originalFunction.id ? originalFunction.id.name : 'anonymous';
            const newNode = NodeFactory_1.NodeFactory.functionDeclarationNode(functionName, originalFunction.params, newBody);
            newNode.async = originalFunction.async;
            newNode.generator = false;
            NodeUtils_1.NodeUtils.parentizeAst(newNode);
            return newNode;
        }
        if (NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(originalFunction)) {
            const hasRestPattern = originalFunction.params.some((param) => NodeGuards_1.NodeGuards.isRestElementNode(param) && !NodeGuards_1.NodeGuards.isIdentifierNode(param.argument));
            let params = originalFunction.params;
            if (hasRestPattern) {
                params = [
                    {
                        type: 'RestElement',
                        argument: {
                            type: 'Identifier',
                            name: VMConstants_1.VM_SPECIAL_VARS.arrowRestParam
                        }
                    }
                ];
            }
            const arrowNode = {
                type: 'ArrowFunctionExpression',
                params: params,
                body: newBody,
                expression: false,
                async: originalFunction.async,
                metadata: { ignoredNode: false }
            };
            NodeUtils_1.NodeUtils.parentizeAst(arrowNode);
            return arrowNode;
        }
        const newNode = NodeFactory_1.NodeFactory.functionExpressionNode(originalFunction.params, newBody);
        newNode.async = originalFunction.async;
        newNode.generator = false;
        newNode.id = originalFunction.id;
        NodeUtils_1.NodeUtils.parentizeAst(newNode);
        return newNode;
    }
    isFunctionNode(node) {
        return (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node) ||
            NodeGuards_1.NodeGuards.isFunctionExpressionNode(node) ||
            NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(node));
    }
    isNestedFunction(node, parentNode) {
        if (!this.isFunctionNode(node)) {
            return false;
        }
        let currentParent = parentNode;
        let depth = 0;
        while (currentParent && depth < 100) {
            if (this.isFunctionNode(currentParent)) {
                return true;
            }
            if (NodeGuards_1.NodeGuards.isProgramNode(currentParent)) {
                return false;
            }
            currentParent = currentParent.parentNode;
            depth++;
        }
        return false;
    }
    containsNestedFunctions(blockStatement) {
        for (const statement of blockStatement.body) {
            if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement)) {
                return true;
            }
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(statement)) {
                for (const declarator of statement.declarations) {
                    if (declarator.init &&
                        (NodeGuards_1.NodeGuards.isFunctionExpressionNode(declarator.init) ||
                            NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(declarator.init))) {
                        return true;
                    }
                }
            }
            if (NodeGuards_1.NodeGuards.isExpressionStatementNode(statement)) {
                const expr = statement.expression;
                if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(expr) || NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(expr)) {
                    return true;
                }
            }
        }
        return false;
    }
    extractIdentifiersFromPattern(pattern) {
        const identifiers = [];
        if (NodeGuards_1.NodeGuards.isObjectPatternNode(pattern)) {
            for (const property of pattern.properties) {
                if (NodeGuards_1.NodeGuards.isPropertyNode(property)) {
                    const value = property.value;
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(value)) {
                        identifiers.push(value.name);
                    }
                    else if (NodeGuards_1.NodeGuards.isObjectPatternNode(value) || NodeGuards_1.NodeGuards.isArrayPatternNode(value)) {
                        identifiers.push(...this.extractIdentifiersFromPattern(value));
                    }
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(property)) {
                    const argument = property.argument;
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(argument)) {
                        identifiers.push(argument.name);
                    }
                }
            }
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(pattern)) {
            for (const element of pattern.elements) {
                if (element === null) {
                    continue;
                }
                if (NodeGuards_1.NodeGuards.isIdentifierNode(element)) {
                    identifiers.push(element.name);
                }
                else if (NodeGuards_1.NodeGuards.isObjectPatternNode(element) || NodeGuards_1.NodeGuards.isArrayPatternNode(element)) {
                    identifiers.push(...this.extractIdentifiersFromPattern(element));
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(element)) {
                    const argument = element.argument;
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(argument)) {
                        identifiers.push(argument.name);
                    }
                }
                else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(element)) {
                    const left = element.left;
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(left)) {
                        identifiers.push(left.name);
                    }
                    else if (NodeGuards_1.NodeGuards.isObjectPatternNode(left) || NodeGuards_1.NodeGuards.isArrayPatternNode(left)) {
                        identifiers.push(...this.extractIdentifiersFromPattern(left));
                    }
                }
            }
        }
        return identifiers;
    }
    injectVMRuntime(programNode) {
        const vmCodeHelperGroup = this.getVMCodeHelperGroup();
        const customCodeHelpers = vmCodeHelperGroup.getCustomCodeHelpers();
        const vmRuntimeHelper = customCodeHelpers.get(CustomCodeHelper_1.CustomCodeHelper.VMRuntime);
        if (vmRuntimeHelper) {
            const vmRuntimeNode = vmRuntimeHelper.getNode();
            NodeAppender_1.NodeAppender.prepend(programNode, vmRuntimeNode);
            const vmGlobalsName = this.extractVMGlobalsNameFromNode(vmRuntimeNode);
            if (vmGlobalsName) {
                this.topLevelVariables = this.vmGlobalStorageUtils.transformTopLevelDeclarations(programNode, vmGlobalsName);
                this.processPendingGlobalStorageNodes(vmGlobalsName);
                this.processPendingCatchClauses(vmGlobalsName);
            }
        }
        return programNode;
    }
    extractVMGlobalsNameFromNode(vmRuntimeNode) {
        if (vmRuntimeNode.length === 0) {
            return null;
        }
        const firstStatement = vmRuntimeNode[0];
        if (!NodeGuards_1.NodeGuards.isVariableDeclarationNode(firstStatement)) {
            return null;
        }
        const firstDeclarator = firstStatement.declarations[0];
        if (!firstDeclarator || !NodeGuards_1.NodeGuards.isIdentifierNode(firstDeclarator.id)) {
            return null;
        }
        return firstDeclarator.id.name;
    }
    processPendingGlobalStorageNodes(vmGlobalsName) {
        for (const { node, parentNode } of this.pendingGlobalStorageNodes) {
            if (NodeGuards_1.NodeGuards.isClassDeclarationNode(node)) {
                this.vmGlobalStorageUtils.wrapClassDeclarationWithGlobalStorage(node, parentNode, vmGlobalsName);
            }
            else if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node)) {
                this.vmGlobalStorageUtils.wrapVariableDeclarationWithGlobalStorage(node, parentNode, vmGlobalsName);
            }
            else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node)) {
                this.vmGlobalStorageUtils.wrapFunctionDeclarationWithGlobalStorage(node, parentNode, vmGlobalsName);
            }
        }
        this.pendingGlobalStorageNodes = [];
    }
    processPendingCatchClauses(vmGlobalsName) {
        for (const catchClause of this.pendingCatchClauses) {
            if (!catchClause.param) {
                continue;
            }
            let varNames;
            if (NodeGuards_1.NodeGuards.isIdentifierNode(catchClause.param)) {
                varNames = [catchClause.param.name];
            }
            else if (NodeGuards_1.NodeGuards.isObjectPatternNode(catchClause.param) ||
                NodeGuards_1.NodeGuards.isArrayPatternNode(catchClause.param)) {
                varNames = this.extractIdentifiersFromPattern(catchClause.param);
            }
            else {
                varNames = [];
            }
            const storageStatements = [];
            for (const varName of varNames) {
                const statement = NodeFactory_1.NodeFactory.expressionStatementNode(NodeFactory_1.NodeFactory.assignmentExpressionNode('=', NodeFactory_1.NodeFactory.memberExpressionNode(NodeFactory_1.NodeFactory.identifierNode(vmGlobalsName), NodeFactory_1.NodeFactory.literalNode(varName), true), NodeFactory_1.NodeFactory.identifierNode(varName)));
                NodeUtils_1.NodeUtils.parentizeAst(statement);
                storageStatements.push(statement);
            }
            catchClause.body.body.unshift(...storageStatements);
            NodeUtils_1.NodeUtils.parentizeAst(catchClause.body);
        }
        this.pendingCatchClauses = [];
    }
};
exports.VMTransformer = VMTransformer;
exports.VMTransformer = VMTransformer = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMBytecodeCompiler)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMBytecodeStorage)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMFunctionSelector)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMGlobalStorageUtils)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMOpcodeMapStorage)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMDeadCodeInjector)),
    __param(6, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMMacroOpOptimizer)),
    __param(7, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__ICustomCodeHelperGroup)),
    __param(8, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(9, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMBytecodeCompiler_1.IVMBytecodeCompiler !== "undefined" && IVMBytecodeCompiler_1.IVMBytecodeCompiler) === "function" ? _a : Object, typeof (_b = typeof IVMBytecodeStorage_1.IVMBytecodeStorage !== "undefined" && IVMBytecodeStorage_1.IVMBytecodeStorage) === "function" ? _b : Object, typeof (_c = typeof IVMFunctionSelector_1.IVMFunctionSelector !== "undefined" && IVMFunctionSelector_1.IVMFunctionSelector) === "function" ? _c : Object, typeof (_d = typeof IVMGlobalStorageUtils_1.IVMGlobalStorageUtils !== "undefined" && IVMGlobalStorageUtils_1.IVMGlobalStorageUtils) === "function" ? _d : Object, typeof (_e = typeof IVMOpcodeMap_1.IVMOpcodeMapStorage !== "undefined" && IVMOpcodeMap_1.IVMOpcodeMapStorage) === "function" ? _e : Object, typeof (_f = typeof VMDeadCodeInjector_1.VMDeadCodeInjector !== "undefined" && VMDeadCodeInjector_1.VMDeadCodeInjector) === "function" ? _f : Object, typeof (_g = typeof VMMacroOpOptimizer_1.VMMacroOpOptimizer !== "undefined" && VMMacroOpOptimizer_1.VMMacroOpOptimizer) === "function" ? _g : Object, typeof (_h = typeof TCustomCodeHelperGroupFactory_1.TCustomCodeHelperGroupFactory !== "undefined" && TCustomCodeHelperGroupFactory_1.TCustomCodeHelperGroupFactory) === "function" ? _h : Object, typeof (_j = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _j : Object, typeof (_k = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _k : Object])
], VMTransformer);
